import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { useUiStore } from '@/stores/uiStore'
import AdminSidebar from './AdminSidebar'
import AdminSectionGuard from './AdminSectionGuard'
import { Spinner } from '@/components/ui'
import { cn } from '@/lib/utils'

export default function AdminLayout() {
  const { user, isLoading, checkAuth } = useAuthStore()
  const { sidebarCollapsed } = useUiStore()

  // `isLoading` do authStore comeca em `true` e so e resolvido pelo checkAuth().
  // O DashboardLayout ja fazia isso; aqui faltava, entao abrir /admin direto na URL
  // (ou dar F5 dentro do admin) ficava preso no spinner para sempre.
  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-900">
        <Spinner size="lg" />
      </div>
    )
  }

  // Check if user is admin
  if (!user || user.role !== 'admin') {
    return <Navigate to="/app/dashboard" replace />
  }

  return (
    <div className="min-h-screen bg-neutral-900">
      <AdminSidebar />
      <main className={cn(
        'transition-all duration-300',
        sidebarCollapsed ? 'lg:pl-16' : 'lg:pl-64'
      )}>
        <div className="p-6 lg:p-8">
          {/* R10-15: perfil de acesso decide quais rotas do admin abrem. */}
          <AdminSectionGuard />
        </div>
      </main>
    </div>
  )
}
